import { useQuery } from "@tanstack/react-query";
import { DefaultRatesService } from "@/services/defaultRates";
import { RoleBasedProjectSettlementType } from "@/modules/projects/service/settlementType";

export interface DefaultRatesQueryParams {
  settlementType?: RoleBasedProjectSettlementType;
  validFrom?: string;
}

export const useDefaultRatesQuery = (options?: {
  enabled?: boolean;
  params?: DefaultRatesQueryParams;
}) => {
  const { enabled = true, params } = options || {};

  return useQuery({
    queryKey: ["defaultRates", params],
    queryFn: () =>
      DefaultRatesService.get({
        settlement_type: params?.settlementType,
        valid_from: params?.validFrom,
      }),
    enabled,
  });
};
